function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1243_56)"
}, React.createElement("path", {
  d: "M0 0H6.18182V4.66926H8.5V2.33463H10.8182V0H17V7.00389H14.6818V8.56031H13.1364V10.8949H14.6818V13.2296H17V20.2335H10.8182V17.8988H8.5V15.5642H6.18182V20.2335H0V0Z"
}));
var _ref2 = /*#__PURE__*/React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0_1243_56"
}, React.createElement("rect", {
  width: 17,
  height: 20
})));
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20"
  }, props), _ref, _ref2);
};
export default __webpack_public_path__ + "static/media/kick.49346565.svg";
export { SvgComponent as ReactComponent };